import React from "react";
import MyIpAddress from "./commponents/MyIpAddress";
import IPInfo from "./commponents/IPInfo";
import "./App.css";

function App() {
  return (
    <div className="App">
      <MyIpAddress />
      <IPInfo />
    </div>
  );
}

export default App;
